import clsx from 'clsx';
import Icon from 'components/ui/Icon';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import Button from 'components/ui/ContentBlocks/Button';
import styles from './Inserts.module.scss';
import type { IBlockCtaFields } from 'types/contentful/generated';
import type { Document } from '@contentful/rich-text-types';

type Props = {
  cta: IBlockCtaFields;
  className?: string;
  spacing?: boolean;
};

const Inserts = ({ cta, className, spacing }: Props): JSX.Element => {
  const textContent = documentToHtmlString(
    (cta?.textContent as unknown as { json: Document })?.json,
  );

  return (
    <div className={clsx(styles.wrapper, className, spacing && styles.spacing)}>
      <div className={styles.info}>
        <div
          className={styles.text}
          dangerouslySetInnerHTML={{ __html: textContent }}
        />
        <div className={styles.iconWrapper}>
          <Icon type="Inserts" className={styles.icon} color="#155263" />
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            text={cta.ctaText || ''}
            position="left"
            theme="light"
            triggerLeadForm={cta.triggerLeadForm}
            funnel={cta.funnel}
            link={cta.ctaLink}
            target={cta.target}
            className={styles.button}
          />
        </div>
      </div>
    </div>
  );
};

export default Inserts;
